import React from 'react';
import { createPortal } from 'react-dom';
import { PRIORITY_OPTIONS } from '../../../FlowchartView/TaskNode/PriorityDropdown';
import { PriorityIcon, ChevronDownIcon } from '../icons';

/**
 * PriorityDropdown Component
 * Dropdown for changing priority of selected missions
 */
const PriorityDropdown = ({
  isActive,
  onToggle,
  onPriorityChange,
  menuStyle,
  buttonRef,
}) => {
  return (
    <div className="bulk-actions-toolbar__dropdown-container">
      <button
        ref={buttonRef}
        className={`bulk-actions-toolbar__btn ${isActive ? 'bulk-actions-toolbar__btn--active' : ''}`}
        onClick={(e) => onToggle('priority', e.currentTarget)}
        title="Change priority"
      >
        <PriorityIcon />
        <span>Priority</span>
        <ChevronDownIcon />
      </button>
      {isActive && createPortal(
        <div className="bulk-actions-toolbar__menu" style={menuStyle}>
          {PRIORITY_OPTIONS.map(option => (
            <button
              key={option.id ?? 'none'}
              className="bulk-actions-toolbar__menu-item"
              onClick={() => onPriorityChange(option.id)}
            >
              <span className="bulk-actions-toolbar__priority-dot" style={{ background: option.color }} />
              <span>{option.name}</span>
            </button>
          ))}
        </div>,
        document.body
      )}
    </div>
  );
};

export default PriorityDropdown;
